import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    virtual: {
        id: 'card_image.type.virtual',
        defaultMessage: 'Virtual',
    },
    physical: {
        id: 'card_image.type.physical',
        defaultMessage: 'Physical',
    },
    failed: {
        id: 'card_image.status.failed',
        defaultMessage: 'Failed',
    },
    blocked: {
        id: 'card_image.status.blocked',
        defaultMessage: 'Blocked',
    },
    frozen: {
        id: 'card_image.status.frozen',
        defaultMessage: 'Frozen',
    },
})
